import { useSideBarTemplate } from "./logic";
import { SideBarTemplate } from "./template";

export const SideBar = (): JSX.Element => {
  const logic = useSideBarTemplate();
  return <SideBarTemplate {...logic} />;
};
